import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import type { IconName } from '../../common/icon/icons.type';
import { AvatarComponent } from '../avatar/avatar.component';
import type { AvatarSize } from '../avatar/avatar.types';
import { BadgeComponent } from '../badge/badge.component';
import { HeadingComponent } from '../heading/heading.component';
import type { IconToken } from '../icon/directives/icon-color.directive';
import { IconColorDirective } from '../icon/directives/icon-color.directive';

export type ProviderStatus =
  | string
  | 'connected'
  | 'pending'
  | 'disconnected'
  | 'inactive'
  | 'initial';

@Component({
  selector: 'rt-provider-item',
  templateUrl: './provider-item.component.html',
  styleUrls: ['./provider-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    AvatarComponent,
    HeadingComponent,
    IconColorDirective,
    BadgeComponent,
    TranslatePipe,
  ],
})
export class ProviderItemComponent {
  public readonly headerTpl = input<TemplateRef<any> | null>(undefined!);
  public readonly descriptionTpl = input<TemplateRef<any>>(undefined!);
  public readonly footerTpl = input<TemplateRef<any> | null>(undefined!);
  public readonly icon = input<IconName>(undefined!);
  public readonly imageSrc = input<string | null>(undefined!);
  public readonly iconSize = input<AvatarSize>('base');
  public readonly iconToken = input<IconToken>('colorIconDefault');
  public readonly status = input<ProviderStatus>(undefined!);
  public readonly initials = input<string>(undefined!);
  public readonly compact = input<boolean>(false); // compact version for narrow containers, e.g getting-started-drawer
  @Input({ required: false }) public header?: string;
  @Input() public description: string | null;
}
